export default "__VITE_PUBLIC_ASSET__15a148a5__"